import { Component, OnInit } from '@angular/core';
import {
  faFacebook,
  faInstagram,
  faTwitter
} from '@fortawesome/free-brands-svg-icons';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  public faFacebook = faFacebook;
  public faTwitter = faTwitter;
  public faInsta = faInstagram;

  constructor() {}

  ngOnInit(): void {}
}
